const localState = sessionStorage.getItem('state');
let rootState = {
    examBasicInfoView: {},
    userInfo:{},
    userBindInfo:{},
    simulatedTopicInfo: {},
    selfTrainingList: [],
    simulatedTrainingList: [],
    getExamPaperGroupListByPage: '',
    getExamPaperPositions: '',
    getobjectlist: [],
    getcertificatesummerdatalist: [],
    getsubjectbytype: [],
    getcertificatebalancedatalist: [],
    getcertificatedetaildatalist: [],
    getstudentlastgrade: [],
    getstudentgradelist: [],
    geterrorquestionlist: [],
    getteamlastgrade: [],
    getteamgradelist: [],
    topicLoaded: "",
    questionList: [],
    chatStorylist: [],
    chathistorylist:[],
    getexamschoolcompetitiontasklist: [],
    saveexamschoolcompetitiontask: [],
    getavailablecaselist: [],
    deleteexamschoolcompetitiontask: null,
    publishschoolcompetitiontask: null,
    papercenterlistbypage: [],
    getcompetitionmonitor: [],// - 实时监控-团队
    getindividualcompetitionmonitor:[],// - 实时监控-个人
    getcompetitionrank: [],//总分排名
    getcompetitiondetailrank:[],//成绩明细
    getindividualcompetitionrank: [],//总分排名-个人
    getindividualcompetitiondetailrank:[],//成绩明细-个人
    routermess:'',//路由信息
    savecaseapply:[],//新增/修改申请订单
    practiceerroranalysis:[],//教师 自主分析-错题分析
    getshoolcompetitioncaselist:[],////获取校园赛可购买案例
    practicepersonalanalysis:[],//自主分析 - 个人练习分析
    practicepersonaldetail:[],//自主分析 - 个人练习分析 - 明细
    emulationteamanalysis:[],//模拟分析 - 团队练习分析
    emulationteamanalysisdetail:[],// -模拟分析 - 团队练习分析 - 明细
    examerroranalysisdetail:[],//错题分析
    emulationpersonalanalysisdetail:[],//-模拟分析 - 个人练习分析 - 明细
    getexampaperpostions:[],//-模拟分析 - 个人练习分析 - 岗位信息
    emulationpersonalanalysis:[],//-模拟分析 - 个人练习分析 - 折线图
    leftTimes:0, // 模拟或考试的剩余时间
}
let studentsState = {
    loginData: {},
    serverUrl: '',
    positionId: '',
    examGroupId: '',
    bigDataAnalystSubmit: false,

}
let teachersState = {}

if (localState) {
    let state = JSON.parse(localState)
    studentsState = state.students;
    teachersState = state.teachers;
    rootState.getExamPaperPositions = state.getExamPaperPositions;
    rootState.userInfo = state.userInfo;
    rootState.userBindInfo = state.userBindInfo;
    rootState.routermess = state.routermess;
    rootState.leftTimes = state.leftTimes; // 剩余时间
}

export default {
    rootState,
    studentsState,
    teachersState,
}


// WEBPACK FOOTER //
// ./src/constants/state.js